import React from 'react'
import PropTypes from 'prop-types'
import {get} from 'lodash'
import className from 'classnames'

import PolicySecurity from '@components/PolicySecurity'

const Policy = ({}) => {
  return <PolicySecurity contentKey='policy' />
}

Policy.propTypes = {}

export default Policy
